export const USER_ROLES = {
    ADMIN: "Admin",
    ENOVATE: "User Enovate",
    SIMPLE:  "Simple User"
}